<template>
  <div :class="$parent.experiment.slug">
    <div class="screen-content" :class="'h-' + screen.hash">
      <div v-html="screen.html" @click="click($event)"></div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';

export default {
  name: 'screen',
  props: {
    screen: Object
  },
  data() {
    return {
      goNextAfterSend: true,
      skip: 0
    }
  },
  created() {
    // this.click = _.debounce(this.click, 500, {leading:true, trailing:false});
  },
  mounted() {
    this.goNextAfterSend = true
    this.skip = 0
    this.runBeforeScript()
  },
  updated() {
    this.goNextAfterSend = true
    this.skip = 0
    this.runBeforeScript()
    if (typeof(Event) === 'function') {
      // modern browsers
      window.dispatchEvent(new Event('resize'));
    } else {
      // for IE and other old browsers
      // causes deprecation warning on modern browsers
      var evt = window.document.createEvent('UIEvents');
      evt.initUIEvent('resize', true, false, window, 0);
      window.dispatchEvent(evt);
    }
  },
  methods: {
    click(e) {
      this.$parent.diagData[this.$parent.diagData.length -1].sectionName = this.screen.sectionName ;
      this.$parent.diagData[this.$parent.diagData.length -1].name = this.screen.name ;
      if (e.target.classList.contains('el-go')) {
        this.runAfterScript();
        this.$parent.go(this.skip);
      } else if (e.target.classList.contains('el-send')) {
        this.sendResult({
            'blocknum': this.screen.sectionNum,
            'trialnum': this.$parent.clickOrder,
            'blockcode': this.screen.sectionName,
            'trialcode': this.screen.name,
            'response': e.target.value,
            'statement': this.screen.statement,
            'object': this.screen.object
          },
          ()=>{
            this.runAfterScript();
            if(this.goNextAfterSend) this.$parent.go(this.skip);
          }
        );
      }
    },
    async sendResult(result, callback, onExit) {
      let self = this
      var formData = new FormData()
      let latency = (+new Date() - self.$parent.screenTimeStart)

      var sessionId = this.$parent.getSessionID();
      var url = new URL(window.location.href.replace('/#', ''));
      if (url.search.indexOf("?iid=") === -1) {
        url.search = "?iid=" + sessionId + "&" + url.search.substring(1);
      }
      var now = new Date();
      var date = '' + ('0' + now.getDate()).slice(-2) + ('0' + (now.getMonth()+1)).slice(-2) + now.getFullYear()
      var time = '' + ('0' + now.getHours()).slice(-2) + ':' + ('0' + now.getMinutes()).slice(-2) + ':' + ('0' + now.getSeconds()).slice(-2)

      formData.append('experiment_id', self.$parent.experiment.id)
      formData.append('status', self.$parent.experiment.status)
      formData.append('session', sessionId)
      formData.append('date', date)
      formData.append('time', time)
      formData.append('subject', btoa(url.search + '&_session=' + sessionId + '&src=' + self.$parent.experiment.id))
      if(result.blocknum) formData.append('blocknum', result.blocknum)
      else formData.append('blocknum', this.screen.sectionNum)
      if(result.trialnum) formData.append('trialnum', result.trialnum)
      else formData.append('trialnum', this.$parent.clickOrder)
      if(result.blockcode) formData.append('blockcode', result.blockcode)
      else formData.append('blockcode', this.screen.sectionName)
      if(result.trialcode) formData.append('trialcode', result.trialcode)
      else formData.append('trialcode', this.screen.name)
      formData.append('response', result.response)
      if(result.statement) formData.append('statement', result.statement)
      if(result.object) formData.append('object', result.object)
      formData.append('latency', latency)
      formData.append('url', url.pathname + url.search)
      formData.append('ua', '-')
      var resultsToSave = {};
      formData.forEach((value, key) => {resultsToSave[key] = value})
      let results = [];
      if (localStorage.getItem('results')) results = JSON.parse(localStorage.getItem('results'))
      resultsToSave['name'] = formData.get('trialcode')
      resultsToSave['value'] = formData.get('response')
      results.push(resultsToSave)
      localStorage.setItem('results', JSON.stringify(results))

      var makeRequest = async function(self, count) {
        var counter = count;
        try {
          const response = await fetch(self.$root.newApiUrl + 'results/', {
            method: 'POST',
            body: formData
          });
          if (response.status !== 201) {
            self.sendErrorLog(sessionId+': '+response.status+' '+await response.text(), 'sendResult-error');
          }
          self.$parent.hideSpinner();
          if (onExit) onExit();
        } catch (error) {
          self.$parent.showSpinner();
          self.sendErrorLog(sessionId+': '+JSON.stringify(error, Object.getOwnPropertyNames(error)), 'sendResult-error');
          if (count < 3) {
            makeRequest(self, ++count);
          }
          else {
            self.$parent.hideSpinner();
            if (onExit) onExit();
          }
        } finally {
          if (callback && counter == 1) callback();
        }
      }
      makeRequest(self, 1);
      this.$parent.clickOrder++;
    },
    wait() {
      this.goNextAfterSend = false
    },
    goTo(screen) {
      this.$parent.go(screen)
    },
    goNext() {
      this.$parent.go(this.skip)
    },
    skipScreens(count) {
      this.skip = count
    },
    getLoopIteration() {
      return (this.screen.loopIteration !== null && typeof this.screen.loopIteration !== 'undefined') ? this.screen.loopIteration + 1 : null
    },
    getScreens() {
      return this.$parent.screens
    },
    shuffle(arr) {
      return this.$parent.shuffle(arr)
    },
    getLoopIterationsCount() {
      if(this.screen.loop) {
        let A = this
        try {
          var loop = eval("(function() {" + A.screen.loop + "}())")
        } catch(e) {
          this.sendErrorLog(e, 'loop')
        }
        return (loop.iterations !== null && typeof loop.iterations !== 'undefined') ? loop.iterations : null
      } else return null
    },
    setScreenName(name) {
      this.screen.name = name
    },
    findResult(name) {
      var results = JSON.parse(localStorage.getItem('results'))
      if(!results) return false
      for(var i=0; i<results.length; i++) {
        if(results[i].name === name) return results[i].value
        if(results[i].trialcode === name) return results[i].response
      }
      return false
    },
    checkTargets(callback, trialcodes) {
      var xhr = new XMLHttpRequest()
      if(typeof trialcodes === 'string')
        xhr.open('GET', this.$root.apiUrl + 'v1/results/' + this.$parent.experiment.id + '/' + this.$parent.experiment.status + '/targets?trialcodes=' + trialcodes)
      else
        xhr.open('GET', this.$root.apiUrl + 'v1/results/' + this.$parent.experiment.id + '/' + this.$parent.experiment.status + '/targets')
      xhr.onload = () => {
        var response = JSON.parse(xhr.responseText)
        if (xhr.status === 200 && response.response) {
          if(typeof callback === 'function') callback(response.response)
        } else if (xhr.status === 404) {
          callback([])
        }
      }
      xhr.send()
    },
    setVar(name, value) {
      this.$parent.setVar(name, value)
    },
    getVar(name) {
      return this.$parent.getVar(name)
    },
    async markAsEnded(callback) {
      this.$parent.showSpinner();
      var results = localStorage.getItem('results')
      var formData = new FormData()
      formData.append('results', results)
      var self = this;
      try {
        const response = await fetch(this.$root.apiUrl + 'v1/results/' + this.$parent.experiment.id + '/ended/' + this.$parent.getSessionID(), {
          method: 'POST',
          body: formData
        });
        if (JSON.parse(results).length < (self.$parent.experiment.crn * 0.9)) {
          self.sendErrorLog(JSON.stringify(self.$parent.diagData), 'diag');
        }
        if (response.status === 201) {
          if(typeof callback === 'function') callback(true);
        } else {
          if(typeof callback === 'function') callback(false);
          this.sendErrorLog(this.$parent.getSessionID()+': '+response.status+' '+response.text(), 'markAsEnded-error');
        }
      } catch (error) {
        if(typeof callback === 'function') callback(false)
        this.sendErrorLog(this.$parent.getSessionID()+': '+JSON.stringify(error, Object.getOwnPropertyNames(error)), 'markAsEnded-error');
      }
      this.$parent.hideSpinner();
    },
    async markAsExcluded() {
      this.$parent.showSpinner();
      try {
        const response = await fetch(this.$root.apiUrl + 'v1/results/' + this.$parent.experiment.id + '/excluded/' + localStorage.getItem('session'), {
          method: 'POST'
        });
        if (response.status !== 201) {
          this.sendErrorLog(this.$parent.getSessionID()+': '+response.status+' '+response.text(), 'markAsExcluded-error');
        }
      } catch (error) {
        this.sendErrorLog(this.$parent.getSessionID()+': '+JSON.stringify(error, Object.getOwnPropertyNames(error)), 'markAsExcluded-error');
      }
      this.$parent.hideSpinner();
    },
    async sendErrorLog(error, origin) {
      var url = new URL(window.location.href.replace('/#', ''));
      var formData = new FormData();
      var obj = {
        experiment_id: this.$parent.experiment.id,
        experiment_name: this.$parent.experiment.name,
        experiment_slug: this.$parent.experiment.slug,
        experiment_status: this.$parent.experiment.status,
        section_name: this.screen.sectionName,
        screen_name: this.screen.name,
        origin: origin,
        error: error,
        url: url.pathname + url.search,
        ua: '-'
      };
      Object.keys(obj).forEach(key => {
        formData.append(key, obj[key])
      });
      try {
        await fetch(this.$root.apiUrl + 'v1/felerjs/', {
          method: 'POST',
          body: formData
        });
      } catch (error) {
        console.error(error.message);
      }
    },
    setScreenStatement(statement) {
      this.screen.statement = statement
    },
    setScreenObject(object) {
      this.screen.object = object
    },
    getScreenObject() {
      return this.screen.object;
    },
    runBeforeScript() {
      var toEval = 'var A = this;' + this.screen.scripts.before
      try {
        eval(toEval)
      }
      catch(e) {
        this.sendErrorLog(e, 'before script')
        console.error('Error in before script:')
        console.error(toEval)
        // if (e instanceof SyntaxError) {
          console.error(e.message)
        // } else {
          // throw(e)
        // }
      }
    },
    runAfterScript() {
      var toEval = 'var A = this;' + this.screen.scripts.after
      try {
        eval(toEval)
      }
      catch(e) {
        this.sendErrorLog(e, 'after script')
        console.error('Error in after script:')
        console.error(toEval)
        // if (e instanceof SyntaxError) {
          console.error(e.message)
        // } else {
          // throw(e)
        // }
      }
    }
  }
}
</script>
